import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath } from 'react-router-dom'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Button } from 'shared/components/Button/Button'
import { TaskStatusEnum } from 'shared/components/TaskList/TaskList'

import { useCashSummary } from '../../../hooks/query/useCashSummary'
import { CreditApplicationStatus } from '../../../models/cashSummary'
import { OnboardingChecklist, OnboardingSubChecklist } from '../../../models/onboarding'
import { getUserAndTeammateInfo } from '../../../redux/actions/users/actions'
import { currentTeamSelector } from '../../../redux/selectors/team'
import { currentUserSelector } from '../../../redux/selectors/users'
import {
  ONBOARDING_CREDIT_APPLICATION_ACCEPT,
  ONBOARDING_CREDIT_APPLICATION_WITH_STEP,
} from '../../../Routes'

interface OnboardingCreditApplicationChecklistCtaProps {
  task: OnboardingChecklist | OnboardingSubChecklist
}

const docusignEnabled = true

export function OnboardingCreditApplicationChecklistCta({
  task,
}: OnboardingCreditApplicationChecklistCtaProps) {
  const user = useSelector(currentUserSelector)
  const team = useSelector(currentTeamSelector)
  const { cashSummary } = useCashSummary()
  const creditApplicationStatus = team.credit_status
  const isErrorTask = task.status === TaskStatusEnum.ERROR
  const dispatch = useDispatch()
  const isTeamOwnerOrCreator =
    team.legal_business_owner === user.id ||
    cashSummary?.creditApplication?.createdBy === user.id ||
    // If there is no business owner yet we can allow anybody
    !team.legal_business_owner

  useEffect(() => {
    dispatch(getUserAndTeammateInfo())
  }, [dispatch])

  if (!cashSummary) return null
  const application = cashSummary.creditApplication

  if (
    creditApplicationStatus === CreditApplicationStatus.IN_PROGRESS ||
    creditApplicationStatus === CreditApplicationStatus.NOT_STARTED
  ) {
    return (
      <Button
        size="medium"
        variant="secondary"
        href={generatePath(ONBOARDING_CREDIT_APPLICATION_WITH_STEP, {
          step: isErrorTask ? 'bank-info' : 'owner-info',
        })}
      >
        {isErrorTask ? 'Resume' : 'Start'}
      </Button>
    )
  }

  if (!isTeamOwnerOrCreator) return null

  if (creditApplicationStatus === CreditApplicationStatus.APPROVED) {
    if (!application?.canBeAccepted) {
      return null
    }

    if (!docusignEnabled) return null

    return (
      <FlexBox>
        <Button size="medium" variant="secondary" href={ONBOARDING_CREDIT_APPLICATION_ACCEPT}>
          View credit offer
        </Button>
      </FlexBox>
    )
  }

  return null
}
